export const clearInput = (elementId) => {
  const element = document.getElementById(elementId);

  if (element) {
    element.value = ""
  }
};
